<template>
  <Modal v-model="mallRegisterBusinessTypeConfigModal" :title="$t('key1001848')" width="700" :transfer="false"
    :mask-closable="false" @on-visible-change="mallRegisterBusinessTypeChange">
    <div class="flex flex-wrap mb20">
      <div class="width_110">{{ $t('key1002626') }}</div>
      <RadioGroup v-model="distributorType">
        <Radio v-for="item in businessTypeList" :label="item.value" class="mr35">{{ item.name }}</Radio>
      </RadioGroup>
    </div>
    <template #footer>
      <Button @click="mallRegisterBusinessTypeConfigModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="mallRegisterBusinessTypeBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {saveErpCommonSettingParam} from "@/utils/common";

export default {
  name: 'mallRegisterBusinessTypeConfigModal',
  mixins: [Mixin],
  props: {
    businessTypeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      mallRegisterBusinessTypeConfigModal: false,
      distributorType: 'retail',
      configParamKey: null
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  methods: {
    // 初始化数据
    initMallRegisterBusinessTypeData(paramKey, paramValue) {
      if (paramValue) {
        this.distributorType = paramValue;
      }
      this.configParamKey = paramKey;
      this.mallRegisterBusinessTypeConfigModal = true;
    },
    // 确定
    mallRegisterBusinessTypeBtn() {
      let queryList = [
        {
          businessId: this.userInfo.merchantId,
          paramKey: this.configParamKey,
          paramValue: this.distributorType,
        }
      ];
      saveErpCommonSettingParam(queryList).then(() => {
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000708'));
        this.mallRegisterBusinessTypeConfigModal = false;
        this.$emit('updateConfigData', true);
      });
    },
    // 监听弹窗
    mallRegisterBusinessTypeChange(value) {
      if (!value) {
        this.distributorType = 'retail';
        this.configParamKey = null;
      }
    }
  }
};
</script>

<style lang="less">

</style>
